export enum ApiVersion {
  V1 = 'v1',
}

export enum QontoEnv {
  Production = 'PRODUCTION',
  Sandbox = 'SANDBOX',
  Staging = 'STAGING',
}

export enum StripeEnv {
  Production = 'live',
  Sandbox = 'sandbox',
  Staging = 'staging',
  Local = 'local',
}

export enum Environment {
  Production = 'LIVE',
  Sandbox = 'SANDBOX',
  Staging = 'STAGING',
  CiCd = 'CI-CD',
  Local = 'LOCAL',
}

export enum LogLevel {
  Trace = 10,
  Debug = 20,
  Info = 30,
  Warn = 40,
  Error = 50,
}
export enum BookingEnvironment {
  // PRODUCTION: actually book hotel, send confirmation email
  Production = 'production',
  // SANDBOX: do NOT book hotel, still send confirmation email
  Sandbox = 'sandbox',
  // DEVELOPMENT: do NOT book hotel, do NOT send confirmation email
  Development = 'development',
}

export const BOOKING_API_URLS = {
  [Environment.Production]: 'https://booking-api.revolugo.com',
  [Environment.Sandbox]: 'https://booking-api.sandbox.revolugo.com',
  [Environment.Staging]: 'https://booking-api.staging.revolugo.com',
  [Environment.CiCd]: 'https://booking-api.staging.revolugo.com',
  [Environment.Local]: 'http://127.0.0.1:3001',
}
